import React from 'react';
import { Container, Box, Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import { theme, commonStyles } from '../../../styles/theme';
import { faqs } from './homePageData.jsx';

const FAQTab = () => {
	return (
		<Container maxWidth="lg" sx={{ py: { xs: 4, md: 8 }, px: { xs: 2, sm: 3 } }}>
			<Box sx={{ textAlign: 'center', mb: { xs: 4, md: 8 } }}>
				<Typography variant="h3" sx={{ fontWeight: 800, color: theme.colors.textPrimary, mb: 2 }}>
					Frequently Asked Questions
				</Typography>
				<Typography variant="body1" sx={{ color: theme.colors.textSecondary, maxWidth: 700, mx: 'auto', lineHeight: 1.7 }}>
					Get answers to common questions about features, pricing, and technical details
				</Typography>
			</Box>
			<Box sx={{ maxWidth: 900, mx: 'auto' }}>
				{faqs.map((faq, idx) => (
					<Accordion 
						key={idx} 
						elevation={0} 
						sx={{ 
							...commonStyles.card, 
							borderRadius: '8px !important', 
							mb: 1.5,
							'&:before': { display: 'none' },
							'&:hover': {
								borderColor: '#dc2626',
								transform: 'translateX(4px)'
							},
							'&.Mui-expanded': {
								borderColor: '#dc2626',
								boxShadow: '0 4px 16px rgba(220,38,38,0.3)'
							},
							transition: 'all 0.3s'
						}}
					>
						<AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: theme.colors.primary }} />}>
							<Typography variant="body1" sx={{ fontWeight: 600, color: '#fff' }}>{faq.question}</Typography>
						</AccordionSummary>
						<AccordionDetails sx={{ borderTop: '1px solid rgba(220,38,38,0.2)', pt: 2 }}>
							<Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.8)', lineHeight: 1.7 }}>{faq.answer}</Typography>
						</AccordionDetails>
					</Accordion>
				))}
			</Box>
		</Container>
	);
};

export default FAQTab;
